import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, ButtonGroup, Button } from 'ui';
import Tooltip from 'components/shared/Tooltip';
import Fade from 'components/shared/animated/Fade';
import BadgeEditor from 'components/BadgeEditor';

const ModalContent = ({
  hasError,
  iconName,
  backgroundColor,
  foregroundColor,
  isLoading,
  updateBadge,
  toggleModal,
}) => {
  const [badge, setBadge] = useState({
    iconName,
    backgroundColor,
    foregroundColor,
  });

  return (
    <>
      <Modal.Content className="BadgeEditorModal-content">
        <div className="mb-32">
          <div className="lh-48 fz-32 c-brand-night">
            {t('certifications.badge_editor.title')}
          </div>
          <div className="lh-24 fz-16 c-brand-gray-darker">
            {t('certifications.badge_editor.description')}
          </div>
        </div>
        <Fade in={hasError}>
          <div className="ErrorContainer">
            {hasError && t('common.server_error')}
          </div>
        </Fade>
        <BadgeEditor
          disabled={isLoading}
          iconName={iconName}
          backgroundColor={backgroundColor}
          foregroundColor={foregroundColor}
          onChange={setBadge}
        />
      </Modal.Content>
      <div className="p-32 pt-0">
        <ButtonGroup alignEnd className="ai-c">
          <Button
            disabled={isLoading}
            className="minw-120"
            onClick={toggleModal}
          >
            {t('common.cancel')}
          </Button>
          <Tooltip
            position="top"
            text={
              !badge.isDirty && t('certifications.badge_editor.unchanged_badge')
            }
          >
            <Button
              disabled={!badge.isValid || !badge.isDirty}
              loading={isLoading}
              className="minw-120"
              primary
              onClick={() => updateBadge(badge)}
            >
              {t('common.done')}
            </Button>
          </Tooltip>
        </ButtonGroup>
      </div>
    </>
  );
};

const BadgeEditorModal = ({
  hasError,
  isLoading,
  iconName,
  backgroundColor,
  foregroundColor,
  shown,
  toggleModal,
  updateBadge,
}) => {
  return (
    <Modal
      shown={shown}
      canClickAway={false}
      className="Modal-container BadgeEditorModal bg-gray-lightest"
      onDismiss={toggleModal}
      enableFloatingDismiss
    >
      <ModalContent
        hasError={hasError}
        iconName={iconName}
        backgroundColor={backgroundColor}
        foregroundColor={foregroundColor}
        updateBadge={updateBadge}
        isLoading={isLoading}
        toggleModal={toggleModal}
      />
    </Modal>
  );
};

BadgeEditorModal.propTypes = {
  hasError: PropTypes.bool,
  shown: PropTypes.bool,
  toggleModal: PropTypes.func,
  updateBadge: PropTypes.func,
  isLoading: PropTypes.bool,
  iconName: PropTypes.string,
  backgroundColor: PropTypes.string,
  foregroundColor: PropTypes.string,
};

export default BadgeEditorModal;
